import type { SVGProps } from "react";
const SvgIconServiceStatus = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <path d="M535.11 768h-1a25 25 0 0 1-23.51-20.08l-75.9-379.53-61.19 152.9A25 25 0 0 1 350.3 537H153a25 25 0 0 1 0-50h180.37l86.12-215.28a25 25 0 0 1 47.72 4.38L539.39 637l64.07-224.25a25 25 0 0 1 46.4-4.31L689.15 487H871a25 25 0 0 1 0 50H673.7a25 25 0 0 1-22.36-13.82l-17.46-34.91-74.74 261.6A25 25 0 0 1 535.11 768" />
  </svg>
);
export default SvgIconServiceStatus;
